module.exports = __webpack_public_path__ + "static/media/zr_2_11.e32b42cd.png";